import React from 'react';
import { createRoot } from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';
import App from './App';
import config from './configs/master';
import { isEnvPresent } from './constants/shared/envConstants';

const { datadogApplicationId: applicationId, datadogClientToken: clientToken, appName } = config;

window.ENV = 'production';

if (isEnvPresent()) {
    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: appName,
        env: window.ENV,
        version: '1399d4e1fc56a99860501b55a83216cbc363b9fa',
        sessionSampleRate: 100, // collect data from all sessions
        sessionReplaySampleRate: 100,
        trackUserInteractions: false, // disable to prevent collecting PII
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask', // mask to prevent collecting PII
    });
}

createRoot(document.getElementById('root')).render(<App />);
